import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import {
  ServerIcon,
  ShieldCheckIcon,
  ClockIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline';

const SystemManagement = () => {
  const serviceData = {
    icon: ServerIcon,
    title: 'System Management',
    description: 'Complete management of computer systems and IT infrastructure to ensure optimal performance, security, and reliability for your business operations.',
    gradient: 'from-green-700 to-green-900',
    technologies: [
      'Linux & Windows',
      'Docker & Kubernetes',
      'AWS & Azure',
      'Monitoring Tools',
      'Backup Solutions',
      'Security Software',
    ],
    features: [
      {
        icon: ClockIcon,
        title: '24/7 Monitoring',
        description: 'Continuous monitoring to prevent issues before they impact your business.',
      },
      {
        icon: ShieldCheckIcon,
        title: 'Security Management',
        description: 'Comprehensive security measures to protect your systems and data.',
      },
      {
        icon: WrenchScrewdriverIcon,
        title: 'Maintenance & Updates',
        description: 'Regular maintenance and updates to keep systems running smoothly.',
      },
    ],
    services: [
      'Server Management & Monitoring',
      'Network Administration',
      'Security Implementation',
      'Backup & Disaster Recovery',
      'System Updates & Patches',
      'Performance Optimization',
      'User Management & Support',
      'Infrastructure Planning',
    ],
    whyChoose: [
      'Proactive System Monitoring',
      'Experienced System Administrators',
      'Robust Security Measures',
      'Flexible Support Options',
    ],
  };

  return <ServiceTemplate {...serviceData} />;
};

export default SystemManagement;
